import React, {
  useState, useEffect, useContext, createContext,
} from 'react';

export const Organization = createContext(); // context === redux sama-sama state management
function Index(props) {
  const [pid__, setPid__] = useState();
  const [tagAdd, setTagAdd] = useState();
  const [modal, setModal] = useState(false);
  const [modalAddEmployee, setModalAddEmployee] = useState(false);
  // organization
  const [modalUpdate, setModalUpdate] = useState(false);
  const [dataUpdate, setDataUpdate] = useState();
  // employee
  const [employeeModal, setEmployeeModal] = useState(false);
  const [employeeData, setEmployeeData] = useState();
  const valx = {
    pid__,
    setPid__,
    tagAdd,
    setTagAdd,
    modal,
    setModal,
    modalUpdate,
    setModalUpdate,
    dataUpdate,
    setDataUpdate,
    modalAddEmployee,
    setModalAddEmployee,
    employeeModal,
    setEmployeeModal,
    employeeData,
    setEmployeeData,
  };
  return (
    <Organization.Provider value={valx}>{props.children}</Organization.Provider>
  );
}

export default Index;
